export default __webpack_public_path__ + "fonts/Agipo-Italic.woff2";